define('ShippingMessage.View', [
    'Backbone',
    'jQuery',
    'shipping_message.tpl',
    'underscore',
    'CookiesUtilities'
], function ShippingMessageView(
    Backbone,
    jQuery,
    shippingMessageTpl,
    _,
    CookiesUtils
) {
    'use strict';

    // -------------------------------------------------------------------------------------------------
    // Section: View Definition
    // -------------------------------------------------------------------------------------------------
    return Backbone.View.extend({
        template: shippingMessageTpl,
        events: {
            'click [data-action="close"]': 'closeSticky'
        },
        initialize: function initialize() {
            var envComponet = this.options.container ? this.options.container.getComponent('Environment') : undefined;
            this.listenTo(this.model, 'sync', jQuery.proxy(this, 'render'));

            // get messages from configuration options.
            if (envComponet) {
                this.hasLocalText = envComponet.getConfig('shippingMessage.hasLocalText');
                this.hasLocalLink = envComponet.getConfig('shippingMessage.hasLocalLink');
                this.hasMountainText = envComponet.getConfig('shippingMessage.hasMountainText');
                this.hasMountainLink = envComponet.getConfig('shippingMessage.hasMountainLink');
                this.deliveryDetailsText = envComponet.getConfig('shippingMessage.deliveryDetailsText');
                this.deliveryDetailsLink = envComponet.getConfig('shippingMessage.deliveryDetailsLink');
            }
        },

        closeSticky: function closeSticky() {
            CookiesUtils.setCookie('deliveryMessageAck', true);
        },

        shouldRender: function shouldRender() {
            var hasLocal = _.findWhere(this.model.get('methods'), { local: true });
            var hasMountain = _.findWhere(this.model.get('methods'), { mountain: true });
            var geo = this.model.get('geo');
            var cookie = CookiesUtils.getCookie('deliveryMessageAck');
            return !this.model.isNew() && !cookie && (hasLocal || hasMountain) && geo && geo.city;
        },

        getContext: function getContext() {
            var geo = this.model.get('geo');
            var hasLocal = _.findWhere(this.model.get('methods'), { local: true });
            var hasMountain = _.findWhere(this.model.get('methods'), { mountain: true });

            return {
                shouldRender: this.shouldRender(),
                hasLocal: hasLocal,
                hasMountain: hasMountain,
                city: geo && geo.city,
                cityUpper: geo && geo.city && geo.city.toLocaleUpperCase(),
                country: geo && geo.country,
                hasLocalText: this.hasLocalText,
                hasLocalLink: this.hasLocalLink,
                hasMountainText: this.hasMountainText,
                hasMountainLink: this.hasMountainLink,
                deliveryDetailsText: this.deliveryDetailsText,
                deliveryDetailsLink: this.deliveryDetailsLink
            };
        }
    });
    // -------------------------------------------------------------------------------------------------
});
